import { useEffect } from 'react';
import { useProject } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';
import {
	useAnalyticsEvents,
	fireOperationalAnalytics,
} from '@atlassian/jira-product-analytics-bridge';

const convertToAnalyticsProjectType = (projectType: string) =>
	projectType === 'service_desk' ? 'serviceDesk' : projectType;

/**
 * This hook is designed to track project usage, and will be fired when the user enters a project context.
 *
 * @see https://hello.atlassian.net/wiki/spaces/ANALYTICS/pages/369725581/JSW+Project+Usage+Everything+you+need+to+know
 */
export const useProjectContextReporter = () => {
	const { data: project } = useProject();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const projectId = project?.id;
	const projectType = project?.type;
	const isSimplified = project?.isSimplified;

	useEffect(() => {
		if (projectId == null || projectType == null) {
			return;
		}

		const event = createAnalyticsEvent({});
		fireOperationalAnalytics(event, 'projectContainer entered', {
			projectId,
			projectType: convertToAnalyticsProjectType(projectType),
			nextGenProject: isSimplified,
		});
	}, [createAnalyticsEvent, projectId, projectType, isSimplified]);
};
